import { clearMessages, signOut } from '../store/auth'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Breadcrumb from '../components/Breadcrumb'
import Button from 'react-bootstrap/Button'
import ChangePassword from '../components/ChangePassword'
import Form from 'react-bootstrap/Form'
import { Helmet } from 'react-helmet'
import Patreon from '../components/Patreon'
import Settings from '../components/Settings'
import Spinner from '../components/Spinner'
import classNames from 'classnames'
import { initialize } from '../store/pagedata'
import { push } from 'redux-first-history'
import styles from '../styles/account.module.scss'
import useDarkMode from 'use-dark-mode'

const Account = () => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const error = useSelector((state) => state.auth.error)
  const isLoading = useSelector((state) => state.auth.isLoading)
  const success = useSelector((state) => state.auth.success)
  const auth = useSelector((state) => state.firebase.auth)
  const [showPasswordModal, setShowPasswordModal] = useState(false)

  useEffect(() => {
    dispatch(initialize())
    if (!auth.email) {
      dispatch(push('/signin'))
    }
  }, [])

  const handleHidePasswordModal = () => {
    setShowPasswordModal(false)
    dispatch(clearMessages())
  }

  return (
    <>
      <Helmet>
        <meta name='description' content='EDHREC My Account' />
        <meta name='keywords' content='EDHREC,account' />
        <title>My Account | EDHREC</title>
      </Helmet>
      <ChangePassword
        onHide={() => handleHidePasswordModal()}
        show={showPasswordModal}
      />
      <Breadcrumb breadcrumb={[{ '/account': 'Account' }]} />
      <h4 className='page-heading'>My Account</h4>
      <div
        className={classNames(styles.container, {
          [styles.dark]: darkMode.value,
        })}
      >
        <div className={styles.containerInner}>
          <Patreon />
        </div>
        {/* <Supporter isInitialized={isInitialized} /> */}
        {/* <DeckSync /> */}
        <Settings />
        <div className={styles.containerInner}>
          <Form.Group>
            <h3 className={styles.header}>Account</h3>
          </Form.Group>
          <Form.Group>
            <Button onClick={() => setShowPasswordModal(true)}>
              Change password
            </Button>
          </Form.Group>
          <Form.Group>
            <Button
              disabled={isLoading && !showPasswordModal}
              onClick={() => dispatch(signOut())}
            >
              {isLoading && !showPasswordModal ? <Spinner /> : 'Sign out'}
            </Button>
          </Form.Group>
          {!showPasswordModal && (
            <Form.Group>
              {error && <Alert variant='danger'>{error}</Alert>}
              {success && <Alert variant='success'>{success}</Alert>}
            </Form.Group>
          )}
        </div>
      </div>
    </>
  )
}

export default Account
